import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import axios from "axios";
import { webView } from "../variables/webView";
import { getCookie, isNoEditRoute } from "./helpers";
import useIsNoIframe from "./useIsNoIframe";

function useTypeDecription() {
  const change = useSelector((state) => state.changeLang.change);

  const [content, setContent] = useState(null);
  const { isNoIframe } = useIsNoIframe();

  const getContent = (typeCard) => {
    if (!isNoIframe || !isNoEditRoute) {
      return;
    }
    const description = document.querySelector("#description");
    if (!description && !webView) {
      const locale = change === "en" ? "" : `/${change}`;
      axios(`${locale}/get_generator_second_step/${typeCard}`).then(
        ({ data }) => {
          const article = parse(data.twigArticle).props.children.find(
            (item) => item?.type && item?.props?.className === "container"
          );
          const raiting = parse(data.twigRating);
          const combinedContent = [article, raiting].map((item, index) => ({
            ...item,
            key: index,
          }));
          setContent(combinedContent);
          setTimeout(() => showFooter(), 500);
        }
      );
    }
  };

  useEffect(() => {
    if (!content && !document.getElementById("ratingBlock")) {
      return;
    }
    const beforeVote = document.getElementById("beforeVote");
    const afterVote = document.getElementById("afterVote");
    const showRating = document.getElementById("showRating");
    const ratingGroup = document.getElementById("ratingGroup");
    // const submitButton = document.getElementById("submitButton");
    const averageRating = document.getElementById("averageRating");
    const noRatingDescription = document.getElementById("noRatingDescription");
    const showRatingPercent = document.getElementById("showRatingPercent");

    // const handleRatingChange = () => {
    //   submitButton.classList.remove("d-none");
    // };

    const handleSubmit = () => {
      const selectedStar = document.querySelector('input[name="fst"]:checked');
      const selectedStars = selectedStar.value;
      const page = window.location.href.split("/");
      const pageType = page[page.length - 1];
      if (typeof selectedStars !== "string") {
        return;
      }

      ratingGroup.classList.add("d-none");
      averageRating.classList.remove("d-none");
      noRatingDescription.classList.add("d-none");
      showRating.classList.remove("d-none");
      afterVote.classList.remove("d-none");
      beforeVote.classList.add("d-none");
      // submitButton.classList.add("d-none");
      axios
        .post(`/rating/generator/${pageType}`, {
          rating: selectedStars,
        })
        .then((response) => {
          const data = response.data.ratingData;
          const avg = Number(data.averageRating);
          const votes = Number(data.totalVotes);
          const adjusted = 4 + (avg - 1) / 3;
          const percent = avg * 20;
          const adjustedPercent = adjusted * 20;

          if (avg < 4 && votes > 5) {
            averageRating.textContent = `${averageRating.dataset.average} ${adjusted.toFixed(1)}/5 ${averageRating.dataset.votes} ${votes}`;
            showRatingPercent.style.left = `${adjustedPercent}%`;
          } else {
            averageRating.textContent = `${averageRating.dataset.average} ${avg.toFixed(1)}/5 ${averageRating.dataset.votes} ${votes}`;
            showRatingPercent.style.left = `${percent}%`;
          }

          setCookie(`hasVoted_${pageType}`, "true", 365);
        })
        .catch((error) => {
          console.error(error);
        });

    };

    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }

      document.cookie = `${name}=${
        value || ""
      }${expires}; path=/; SameSite=Lax`;
    }

    function check() {
      const page = window.location.href.split("/");
      const pageType = page[page.length - 1];
      const hasVoted = getCookie(`hasVoted_${pageType}`);
      const selectedStar = document.querySelector('input[name="fst"]:checked');

      if (hasVoted === "true") {
        afterVote.classList.remove("d-none");
        showRating.classList.remove("d-none");
        averageRating.classList.remove("d-none");
        beforeVote.classList.add("d-none");
        ratingGroup.classList.add("d-none");
        noRatingDescription.classList.add("d-none");
      } else {
        if (selectedStar) {
          selectedStar.checked = true;
        }
        beforeVote.classList.remove("d-none");
        noRatingDescription.classList.remove("d-none");
        afterVote.classList.add("d-none");
        showRating.classList.add("d-none");
        averageRating.classList.add("d-none");
      }
    }

    if (!ratingGroup.dataset.eventBound) {
      ratingGroup.addEventListener("change", handleSubmit);
      // submitButton.addEventListener("click", handleSubmit);
      ratingGroup.dataset.eventBound = "true";
    }
    check();

    return () => {
      ratingGroup.removeEventListener("change", handleSubmit);
      // submitButton.removeEventListener("click", handleSubmit);
    };
  }, [content]);

  const pasteBottomDescription = () => {
    document
      .querySelector("#description")
      ?.classList.remove("position-absolute");
  };

  const removeDescription = () => {
    document.querySelector("#description")?.remove();
  };

  const showFooter = () => {
    if (!webView) {
      document.querySelector("#footer")?.classList.remove("d-none");
    }
  };

  const hideFooter = () => {
    document.querySelector("#footer")?.classList.add("d-none");
  };

  return {
    content,
    getContent,
    pasteBottomDescription,
    removeDescription,
    showFooter,
    hideFooter,
  };
}
export default useTypeDecription;
